module.exports = __webpack_public_path__ + "img/ouro.1a463ae5.png";